  // ...existing imports and decorator...
import { Component, OnInit, Input, ViewChild, inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { SelectItem, TreeNode } from "primeng/api";
import { TableComponent } from "./table/table.component";
import { ActivatedRoute } from "@angular/router";
import { OnDestroy } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
    selector: "app-peer-to-peer",
    templateUrl: "./peer-to-peer.component.html",
    styleUrls: ["./peer-to-peer.component.css"],
    standalone: false
})
export class PeerToPeerComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  private route = inject(ActivatedRoute);

  @Input() headerEnabled = true;
  @Input() adminId: any = null;
  @Input() locId: any = null;
  @Input() deId = false;
  @Input() chartFilter: any = null;
  bgcolors: string[] = ["bg-primary", "bg-danger", "bg-warning"];
  nursingAuditNodes: TreeNode[] = [];
  displayCommentDialog = false;
  isLoaded!: boolean;
  days: SelectItem[];
  filter: any = {};
  filterValues: any = {};
  dissableDeIdSwitch = false;
  @ViewChild("table") table!: TableComponent;
  private readonly destroy$ = new Subject<void>();

  constructor() {
    this.days = [
      { label: "90 Days", value: 600 },
      { label: "30 Days", value: 30 },
      { label: "7 Days", value: 7 },
    ];
  }

  ngOnInit(): void {
    const deIdState = this.authService.getDeIdState();
    this.deId = deIdState.value;
    this.dissableDeIdSwitch = deIdState.disabled;
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.deId = this.authService.isDemoUser() ? true : x.deId;
    });
    const body = document.getElementsByTagName("body")[0];
    body.className = "";
    body.classList.add("subpage");
    body.classList.add("p2p");
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updatedFilterValue(filter: any) {
    this.filterValues = { ...filter };
  }


  removeFilter(filter: any) {
    this.table.removePeertoPeerFilters(filter);
  }

  clearAllFilterPills(filter: any = {}) {
    this.filterValues = { ...(filter || {}) };
  }

  updateDeIdMode(value: boolean) {
    if (!this.authService.isDemoUser()) {
      this.deId = value;
      this.authService.setDeIdentified(value);
    }
  }

  openFilterModuleAfterMore(filterInputs: any) {
    this.table.openPeertoPeerFilter(filterInputs);
  }
}
